import { AppRoutesSearchParams } from '@/constants';
import { setSharedDataInitialPageId, useAppDispatch } from '@/store';
import { removeSearchParams } from '@/utils';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

export const useGetPageIdInViewportOnInit = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const pageIdInViewportOnInit = searchParams.get(AppRoutesSearchParams.pageIdInViewportOnInit);
    dispatch(setSharedDataInitialPageId(pageIdInViewportOnInit));

    /**
     * Remove AppRoutesSearchParams.pageIdInViewportOnInit from url path
     */
    if (pageIdInViewportOnInit) {
      const keysToRemove = [AppRoutesSearchParams.pageIdInViewportOnInit];
      const updatedParams = removeSearchParams(keysToRemove, searchParams);

      if (updatedParams) {
        setSearchParams(updatedParams, { replace: true });
      }
    }

    return () => {
      dispatch(setSharedDataInitialPageId(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
